var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgRedSiftLogomark = function SvgRedSiftLogomark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.638 40.77 2.36 3.968 9.776-16.283h-4.88l-7.256 12.316Z",
    fill: "#FF8181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.877 28.455h4.88L34.89 12.208l-2.324 4.075 7.31 12.172Z",
    fill: "#FFB3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.238 28.455h-4.88l9.777 16.284h4.88l-2.449-4.076-7.328-12.208Z",
    fill: "#FF1212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.238 28.455 7.328-12.172 2.324-4.075H12.208v32.584h4.88v-27.74h10.098L20.34 28.455h4.898Z",
    fill: "#C30E0E"
  })));
};
export default SvgRedSiftLogomark;